import React, { useState } from 'react';
import Cookies from 'universal-cookie';
import logo from '../../images/logo.svg';

const cookies = new Cookies();

const ChevronDown = () => (
  <svg width="9" height="9" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0, opacity: 0.5 }}>
    <path d="M903.232 256l56.768 50.432L512 768 64 306.432 120.768 256 512 659.072z" fill="currentColor" />
  </svg>
);

const origin = document.location.protocol + '//' + document.location.host;

export default function AopNav({ user, onMenuToggle }) {
  const [openMenu, setOpenMenu] = useState(null);

  const picture = user?.picture;
  const initials = user?.name
    ? user.name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase()
    : 'U';

  // Tap toggles the dropdown (mobile has no hover); hover still opens on desktop.
  const toggleMenu = (name) => setOpenMenu((cur) => (cur === name ? null : name));

  return (
    <header className="aop-header-wrapper">
      <nav className="aop-top-navigation">

        <button
          type="button"
          className="aop-menu-btn"
          onClick={onMenuToggle}
          aria-label="Open navigation menu"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        {/* Logo + app label + dropdown */}
        <div
          className="aop-menu-item"
          onMouseEnter={() => setOpenMenu('app')}
          onMouseLeave={() => setOpenMenu(null)}
        >
          <div className="aop-btn-logo" onClick={() => toggleMenu('app')}>
            <img src={logo} alt="Upsellit" className="aop-nav-icon" />
            <span className="aop-nav-app-label">AOP <ChevronDown /></span>
          </div>
          <div className={`aop-sub-menu${openMenu === 'app' ? ' open' : ''}`}>
            <ul>
              <li><a href={origin + '/'}>CSD</a></li>
              <li><a href={origin + '/wiki'}>Wiki</a></li>
              <li><a href="https://www2.upsellit.com/admin/control/edit/index.jsp" target="_blank" rel="noreferrer">Admin</a></li>
              <li><a href="https://upsellit.lightning.force.com/lightning" target="_blank" rel="noreferrer">Salesforce</a></li>
            </ul>
          </div>
        </div>

        <div className="aop-nav-spacer" />

        {/* Profile + dropdown */}
        <div
          className="aop-menu-item"
          onMouseEnter={() => setOpenMenu('profile')}
          onMouseLeave={() => setOpenMenu(null)}
        >
          <div className="aop-profile-trigger" onClick={() => toggleMenu('profile')}>
            {picture ? (
              <div className="aop-profile-button" style={{ backgroundImage: `url(${picture})` }} />
            ) : (
              <div className="aop-profile-initials">{initials}</div>
            )}
            <ChevronDown />
          </div>
          <div className={`aop-sub-menu aop-sub-menu-right${openMenu === 'profile' ? ' open' : ''}`}>
            <ul>
              <li><a href={origin + '/'}>CSD</a></li>
              <li><a href="/wiki/csd_overview">Help</a></li>
              <li>
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  const theme = cookies.get('theme') || 'dark';
                  if (theme === 'light') {
                    cookies.set('theme', 'dark', { path: '/', maxAge: 315360000 });
                    document.documentElement.id = 'dark';
                  } else {
                    cookies.set('theme', 'light', { path: '/', maxAge: 315360000 });
                    document.documentElement.id = 'light';
                  }
                }}>
                  Theme
                </a>
              </li>
            </ul>
          </div>
        </div>

      </nav>
    </header>
  );
}
